
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["src-render-demo-render"],
  getter: () => import(/* webpackChunkName: "meta__Render__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.en.md?type=demo')
};